import React, { Fragment } from "react";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import { AutoCompleteInput, MoneyInput, IntegerInput, DatePicker } from "components/Global/FormikMaterial";
import { aggregateInterestMethods } from "components/Calculators/Constants/DropDownLists";

const StyledDatePicker = styled(DatePicker)`
  & {width:100%;
    margin-top:-2px !important;
  }
`;
const StyledAutoCompleteInput = styled(AutoCompleteInput)`
  & {width:100%;}
`;
const StyledIntegerInput = styled(IntegerInput)`
  & {width:100%;}
`;
const StyledMoneyInput = styled(MoneyInput)`
  & {width:100%;}
`;
const StyledLabel = styled.div`{
  //styleName: Work Sans / 16 Medium;
  font-family: Work Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
 }`;
const AggregateInterestFields = ({ aggregateInterestMethod }) => (
  <>
    <Grid item xs={6}>
      <StyledDatePicker
        label={<StyledLabel>{"Prepayment Date"}</StyledLabel>}
        fieldName="prepaymentDate"
      />
    </Grid>
    <Grid item xs={6}>
      <StyledAutoCompleteInput
        label={<StyledLabel>{"Method"}</StyledLabel>}
        fieldName="aggregateInterestMethod"
        selectValue="value"
        options={aggregateInterestMethods}
      />
    </Grid>
    {
      aggregateInterestMethod === "DEFINED" &&
        <Grid item xs={6}>
          <StyledMoneyInput
            label={<StyledLabel>{"Amount"}</StyledLabel>}
            fieldName="definedAggregateInterestAmount"
          />
        </Grid>
    }
    {
      aggregateInterestMethod === "FORMULAIC" &&
        <Grid item xs={6}>
          <StyledIntegerInput
            label={<StyledLabel>{"Months of Interest"}</StyledLabel>}
            fieldName="monthsOfInterest"
          />
        </Grid>
    }
  </>
);
export default AggregateInterestFields;
